import { useMainStore } from '@/store';
import type { TableState } from '@/store/modules/table';

export const getTableModule = (): TableState => useMainStore().table;

export const getTableQuery = () => getTableModule().query;

export const getTableQueryTemporary = () => getTableModule().queryTemporary;

export const getTableActiveReports = () => getTableModule().activeReports;

export const getTableActiveTabStack = () => getTableModule().activeTabStack;

export const getTableSelectedReport = () => getTableModule().selectedReport;

export const getTableFilters = () => getTableModule().filters;

export const setTableSelectedReport = (value: string | null) => {
  getTableModule().selectedReport = value;
};

export const setTableActiveReports = (reports: TableState['activeReports']) => {
  getTableModule().activeReports = reports;
};
